import { render } from "./EfirmaHome.vue?vue&type=template&id=4b9ed4f4&ts=true"
import script from "./EfirmaHome.vue?vue&type=script&lang=ts"
export * from "./EfirmaHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__